import { createContext, useContext, useEffect, useState } from "react";

const LangCtx = createContext({ lang: "fr", setLang: () => {}, tr: (a) => a });

export const LanguageProvider = ({ children }) => {
    const [lang, setLangState] = useState(() => localStorage.getItem("cr-lang") || "fr");

    const setLang = (l) => {
        localStorage.setItem("cr-lang", l);
        setLangState(l);
    };

    useEffect(() => {
        document.documentElement.lang = lang;
    }, [lang]);

    const tr = (a, b) => {
        if (a && typeof a === "object") return lang === "en" ? a.en : a.fr;
        return lang === "en" ? b : a;
    };

    return <LangCtx.Provider value={{ lang, setLang, tr }}>{children}</LangCtx.Provider>;
};

export const useLang = () => useContext(LangCtx);
